import { jsx as _jsx } from "react/jsx-runtime";
export const SvgMinus = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'M7 12h10' }) }));
//# sourceMappingURL=minus.js.map